import { axios } from '@/lib/axios';

export const updateCorp = async (id: number, isActive: boolean) => {
    const { success, message } = await axios.post(`v1/update-corporation/${id}`, {
        corporate_active: isActive,
    });

    return { success, message };
};
